import { Injectable } from '@angular/core';
import { MessageService, MessageTtsLimit } from './message.service';
import { SettingsService } from './settings.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingService {

  constructor(
    private messageService: MessageService,
    private settingsService: SettingsService
  ) { }

  public handleTtsDailyLimit() {
    console.log('showTtsDailyLimitPrompt');
    let voiceType = this.settingsService.getSelectedVoiceType();
    this.messageService.sendMessage({ name: MessageTtsLimit, data: { type: voiceType } });
  }
}
